module.exports = __webpack_public_path__ + "img/Background1.39358849.jpg";